import { mapKeys, mapValues, snakeCase } from 'lodash'

import { baseConsumerUrl, basePartnerpageUrl } from 'embed/constants/config'
import { urlSerialize } from 'embed/utils'
import {
  Brand,
  ClientTags,
  ConsumerProductPath,
  FILTER_QUERY_PARAM_PREFIX,
  Filters,
  Product,
  QueryParamKeys,
} from 'even-ts-static'
import { TAG_PREFIX } from '../QueryParams'

export interface PartnerpageParams {
  creditScore?: string
  loanAmount?: number
  purpose?: string

  dateOfBirth?: string
  education?: string
  email?: string
  firstName?: string
  lastName?: string

  streetAddress1?: string
  streetAddress2?: string
  zipcode?: string

  employment?: string

  monthlyIncome?: number
  monthlyDebt?: number
  totalAssets?: number

  transactionType?: string
  propertyCounty?: string
  propertyState?: string
  propertySearchStatus?: string
  propertyType?: string
  propertyValue?: number
  downPayment?: number
  refinanceType?: string
  refinanceAmount?: number
  cashOutAmount?: number
  numUnits?: string
  purchaseStatus?: string
  closingDate?: string
  purchaseDate?: string
  occupancyType?: string

  isTest?: boolean
  trackingUuid?: string
}

export type ConsumerPartnerPageParams = { [K in QueryParamKeys]?: unknown }

const cleanParams = (params: PartnerpageParams | ConsumerPartnerPageParams) =>
  Object.keys(params).reduce((acc, key) => {
    if (params[key] && params[key] !== '') acc[key] = params[key]
    return acc
  }, {})

const serializePageParams = (params: PartnerpageParams | ConsumerPartnerPageParams) =>
  mapKeys(cleanParams(params), (value, key) => snakeCase(key))

const serializeFilterParams = (params: Filters) =>
  mapKeys(cleanParams(params), (value, key: string) => FILTER_QUERY_PARAM_PREFIX + key)

const serializeClientTagParams = (params: ClientTags) => {
  let serializedParams = { ...params }
  serializedParams = mapKeys(serializedParams, (value, key: string) => TAG_PREFIX + key)

  return mapValues(serializedParams, (value, key) => (Array.isArray(value) ? value[0] : value))
}

export const buildPartnerpageUrl = (partnerKey: string, pageParams: PartnerpageParams = {}) => {
  const serializedPageParams = serializePageParams(pageParams)

  return `${basePartnerpageUrl}/${partnerKey}/advanced-search/?${urlSerialize(serializedPageParams)}`
}

export const buildConsumerPartnerPageUrl = (
  product: Product | 'Preferred',
  pageParams: ConsumerPartnerPageParams = {},
  filterParams: Filters,
  clientTagParams: ClientTags,
  partnerKey = '',
) => {
  const serializedPageParams = serializePageParams(pageParams)
  const serializedFilters = serializeFilterParams(filterParams)
  const serializedClientTags = serializeClientTagParams(clientTagParams)

  let url = baseConsumerUrl
  if (partnerKey !== '' && partnerKey !== Brand.Even && partnerKey !== Brand.Fiona && partnerKey !== Brand.LeapLife) {
    url += `/${partnerKey}`
  }
  url += `/${ConsumerProductPath[product]}`
  return `${url}?${urlSerialize(serializedPageParams)}&${urlSerialize(serializedFilters)}&${urlSerialize(
    serializedClientTags,
  )}`
}
